export const TOGGLE_PASSWORD_SHOW_HIDE = "sub-users/TOGGLE_PASSWORD_SHOW_HIDE";

export default function togglePasswordShowHideAction() {
  return {
    "payload": null,
    "type": TOGGLE_PASSWORD_SHOW_HIDE
  };
}
